import { Item, Util } from '@ntap/core';
import {
  FQAN_razina,
  Razina,
  TYPE_jedinica_gradiva
} from '../hierarhija/hierarhija.component';

const ATTR_folder_id = 'folder_id';
const ATTR_predmet_id = 'predmet_id';
const ATTR_pismeno_id = 'pismeno_id';
const ATTR_locked = 'locked';
const FQAN_jedgrad_folder_id = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  ATTR_folder_id
);
const FQAN_jedgrad_predmet_id = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  ATTR_predmet_id
);
const FQAN_jedgrad_pismeno_id = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  ATTR_pismeno_id
);

const FQAN_jedgrad_locked = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  ATTR_locked
);

export enum DokType {
  NONE,
  FOLDER,
  PREDMET,
  PISMENO
}

export class DokItemInfo {
  razina: Razina;
  dokType: DokType;
  permission: number;
  locked: boolean;
  parent?: DokItemInfo;

  constructor(item: any) {
    this.razina = item[FQAN_razina];
    this.dokType = findDokType(item);
    this.permission = item['$permission'];
    this.locked = item[FQAN_jedgrad_locked];
    this.parent = item['$parent']?.['$parentId']
      ? new DokItemInfo(item['$parent']['$parent'])
      : undefined;
  }
}

const MARKER_ATTRS: string[] = [
  FQAN_jedgrad_folder_id,
  FQAN_jedgrad_predmet_id,
  FQAN_jedgrad_pismeno_id
];
const MARKER_DOKTYPE: any = {
  [FQAN_jedgrad_folder_id]: DokType.FOLDER,
  [FQAN_jedgrad_predmet_id]: DokType.PREDMET,
  [FQAN_jedgrad_pismeno_id]: DokType.PISMENO
};

function getMarkerAttribute(item: any) {
  return MARKER_ATTRS.find((fqan) => !!item[fqan]);
}

export function findDokType(item: Item): DokType {
  const markerAttr = getMarkerAttribute(item);
  return markerAttr ? MARKER_DOKTYPE[markerAttr] ?? DokType.NONE : DokType.NONE;
}
